export const formTemplates = [
  {
    description: '表单模板详细说明...',
    imgUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/t1.png',
    jsonUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/json1.json',
    title: '单列表单',
  },

  {
    description: '表单模板详细说明...',
    imgUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/t2.png',
    jsonUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/json2.json',
    title: '多列表单',
  },

  {
    description: '表单模板详细说明...',
    imgUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/t3.png',
    jsonUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/json3.json',
    title: '折叠表单',
  },

  {
    description: '表单模板详细说明...',
    imgUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/t4.png',
    jsonUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/json4.json',
    title: '标签页表单',
  },

  {
    description: '表单模板详细说明...',
    imgUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/t5.png',
    jsonUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/json5.json',
    title: '主从表单',
  },
  {
    description: '表单模板详细说明...',
    imgUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/t6.png',
    jsonUrl: 'https://vform2022.ks3-cn-beijing.ksyuncs.com/vform-mobile-templates/json6.json',
    title: '问卷调查表',
  },
];
